/* eslint-disable function-paren-newline */
/* eslint-disable complexity */
/* eslint-disable object-property-newline */
import Button from "@atlaskit/button";
import { ReactElement, useContext, useEffect, useState } from "react";
import "./PriorityList.scss";
import { MessageContext } from "../../contexts/Message/MessageContext";
import APIService from "../../services/API";
import DynamicTable from "@atlaskit/dynamic-table";
import { RankEnd } from "@atlaskit/dynamic-table/dist/types/types";
import { CoachPriority } from "../../types/CoachPriority";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}

export function PriorityList({}: Props): ReactElement {
    const messageContext = useContext(MessageContext);
    const [data, setData] = useState<CoachPriority[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        APIService.HandleGetRequest<any[]>("/coach-priority")
            .then((response) => setData(response))
            .catch(() =>
                messageContext.actions.showErrorMessage(
                    "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!            "
                )
            )
            .finally(() => setLoading(false));
    }, []);

    const submit = () => {
        APIService.handlePostRequest<CoachPriority[], CoachPriority[]>(
            data,
            "/coach-priority"
        )
            // eslint-disable-next-line no-console
            .then(console.debug)
            .catch(() => {
                messageContext.actions.showErrorMessage(
                    "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut!            "
                );
            });
        return 1;
    };

    const head = {
        cells: [
            {
                key: "user.firstname",
                content: "Vorname",
                width: 5,
            },
            {
                key: "user.lastname",
                content: "Nachname",
                width: 5,
            },
            {
                key: "priority",
                content: "Priorität",
                width: 10,
            },
        ],
    };
    const convertedData = data.map((cell: any) => ({
        firstname: cell.username?.split(" ")[0] ?? "-",
        lastname: cell.username?.split(" ")[1] ?? "-",
        priority: cell.priority,
    }));
    const sortedData = [...convertedData].sort(
        (firstItem, secondItem) => firstItem.priority - secondItem.priority
    );
    const rows = sortedData.map((cell: any, index: number) => ({
        key: `row-${index}-${cell.name}`,
        isHighlighted: false,
        cells: [
            {
                key: "user.firstname",
                content: cell.firstname,
            },
            {
                key: "user.lastname",
                content: cell.lastname,
            },
            {
                key: "userInsuranceName",
                content: cell.priority,
            },
        ],
    }));

    function updatePriorityList(event: RankEnd) {
        const { sourceIndex, destination } = event;

        let updatedData = [...data];
        const [movedItem] = updatedData.splice(sourceIndex, 1);

        if (destination) {
            // Insert the moved item at its new position
            updatedData.splice(destination.index, 0, movedItem);
            updatedData = updatedData.map((item, index) => ({
                ...item,
                priority: index + 1,
            }));
            setData(updatedData);
        }
    }

    return (
        <div className="form-wrapper">
            <div
                className="buttons-cont"
                // eslint-disable-next-line object-property-newline
                style={{ margin: 10, maxWidth: 800 }}
            >
                <DynamicTable
                    caption={
                        <div className="caption-wrapper">
                            Care Team nach Prioritäten
                        </div>
                    }
                    isLoading={loading}
                    head={head}
                    rows={rows}
                    rowsPerPage={10}
                    defaultPage={1}
                    isFixedSize
                    onRankEnd={updatePriorityList}
                    isRankable
                />
                <div className="submit">
                    <Button appearance="primary" onClick={() => submit()}>
                        Änderungen speichern
                    </Button>
                </div>
            </div>
        </div>
    );
}
